import { AccountSettingsItems } from "@components/mainInterface/UserDropdown/AccountSettingsItems";
import { ReferralModalTrigger } from "@components/mainInterface/UserDropdown/ReferralModalTrigger";

export const PersonalViewUserDropdownItems: React.FC = () => (
    <>
        <AccountSettingsItems />
        <ReferralModalTrigger />
    </>
);
